export default "__VITE_ASSET__e3d3bc8d__"